import { t } from 'i18next';
import React from 'react';
import PageLayout from 'src/app/components/PageLayoutComponent/PageLayout';
import { ICustomTabs } from 'src/app/components/TabLayoutComponent/tab-layout.config';
import TabLayout from 'src/app/components/TabLayoutComponent/TabLayout';
import { getPermissionKey } from 'src/app/helpers/permission.helper';
import BlackSystem from 'src/app/pages/PortalPage/BlackSystemPage/BlackSystem';
import ConfigSettings from 'src/app/pages/PortalPage/ConfigSettings/ConfigSettings';
import CustomerInvitations from 'src/app/pages/PortalPage/CustomerAndUserInvitationsPage/CustomerInvitaions/CustomerInvitations';
import UserInvitations from 'src/app/pages/PortalPage/CustomerAndUserInvitationsPage/UserInvitations/UserInvitations';
import CustomerAndUserPage from 'src/app/pages/PortalPage/CustomerAndUserPage/CustomerAndUserPage';
import ExchangeRates from 'src/app/pages/PortalPage/ExchangeRates/ExchangeRates';
import SystemLogsPage from 'src/app/pages/PortalPage/SystemLogsPage/SystemLogsPage';
import UserEvents from 'src/app/pages/PortalPage/UserEvents/UserEvents';
import Users from 'src/app/pages/PortalPage/Users/Users';
import ControlPanelComponent from 'src/app/pages/SettingsPage/ControlPanel/ControlPanel';
import { routes } from 'src/configs/permissions.dictionary';
import { LAYOUTVIEW } from 'src/configs/system.config';
import { LayoutViewType } from 'src/enums/user.enum';

const LazySenderEmailSettings = React.lazy(() => import('./SenderEmailSettings/SenderEmailSettings'));

const LazyResourcesPage = React.lazy(() => import('./Resources/Resources'));

const PortalPage = () => {
  // Define portal page tabs
  const tabItems: ICustomTabs[] = [
    {
      key: '1',
      label: t('customerAndUserInvitationsPage.customerInvitations.tabName'),
      children: <CustomerInvitations />,
      permission: getPermissionKey([routes['/Portal'], 'CustomerInvitations']),
      excludeLayouts: [LayoutViewType.SAMA_RED_LAYOUT, LayoutViewType.SAMA_BLACK_LAYOUT],
    },
    {
      key: '2',
      label: t('customerAndUserInvitationsPage.userInvitations.tabName'),
      children: <UserInvitations />,
      permission: getPermissionKey([routes['/Portal'], 'UserInvitations']),
      excludeLayouts: [LayoutViewType.SAMA_RED_LAYOUT, LayoutViewType.SAMA_BLACK_LAYOUT],
    },
    {
      key: '3',
      label: LAYOUTVIEW() === LayoutViewType.SC3_LAYOUT ? t('sidebar.customerAndUser') : t('sidebar.departmentAndUser'),
      children: <CustomerAndUserPage />,
      permission: getPermissionKey([routes['/Portal'], 'CustomerAndUser']),
    },
    {
      key: '4',
      label: `${t('settingsPage.senderEmailSettings.tabName')}`,
      children: <LazySenderEmailSettings />,
      permission: getPermissionKey([routes['/Portal'], 'SenderEmailSettings']),
      excludeLayouts: [LayoutViewType.SAMA_BLACK_LAYOUT],
    },
    {
      key: '5',
      label: t('resourcePage.tabName'),
      children: <LazyResourcesPage />,
      permission: getPermissionKey([routes['/Portal'], 'Resources']),
      excludeLayouts: [LayoutViewType.SAMA_BLACK_LAYOUT],
    },
    {
      key: '6',
      label: `${t('settingsPage.controlPanel.tabName')}`,
      children: <ControlPanelComponent />,
      permission: getPermissionKey([routes['/Portal'], 'ControlPanel']),
      excludeLayouts: [LayoutViewType.SC3_LAYOUT, LayoutViewType.SAMA_BLACK_LAYOUT],
    },
    {
      key: '7',
      label: t('ossConfigPage.tabName'),
      children: <BlackSystem />,
      permission: getPermissionKey([routes['/Portal'], 'OSSConfig']),
      excludeLayouts: [LayoutViewType.SC3_LAYOUT],
    },
    {
      key: '8',
      label: t('systemLogsPage.tabName'),
      children: <SystemLogsPage />,
      permission: getPermissionKey([routes['/Portal'], 'SystemLogs']),
    },
    {
      key: '9',
      label: t('usersPage.tabName'),
      children: <Users />,
      excludeLayouts: [LayoutViewType.SAMA_RED_LAYOUT, LayoutViewType.SC3_LAYOUT],
      permission: getPermissionKey([routes['/Portal'], 'Users']),
    },
    {
      key: '10',
      label: 'User Events',
      children: <UserEvents />,
      excludeLayouts: [LayoutViewType.SAMA_BLACK_LAYOUT],
      permission: getPermissionKey([routes['/Portal'], 'UserEvents']),
    },
    {
      key: '11',
      label: 'Config Settings',
      children: <ConfigSettings />,
      excludeLayouts: [LayoutViewType.SAMA_BLACK_LAYOUT],
      // permission: getPermissionKey([routes['/Portal'], 'ExchangeRates']),
    },
    {
      key: '12',
      label: 'Exchange Rates',
      children: <ExchangeRates />,
      excludeLayouts: [LayoutViewType.SAMA_BLACK_LAYOUT],
      // permission: getPermissionKey([routes['/Portal'], 'ExchangeRates']),
    },
  ];
  return (
    <PageLayout title={t('header.menu.portal')}>
      <TabLayout paramName="tab" items={tabItems} />
    </PageLayout>
  );
};

export default PortalPage;
